var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLink(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.34655 1.85646C8.32838 1.81255 8.30152 1.7714 8.26596 1.73563C8.26543 1.7351 8.2649 1.73457 8.26437 1.73404C8.19657 1.66665 8.10315 1.625 8 1.625H3C2.79289 1.625 2.625 1.79289 2.625 2C2.625 2.20711 2.79289 2.375 3 2.375H7.09467L1.73483 7.73484C1.58839 7.88128 1.58839 8.11872 1.73483 8.26516C1.88128 8.41161 2.11872 8.41161 2.26517 8.26516L7.625 2.90533V7C7.625 7.20711 7.79289 7.375 8 7.375C8.20711 7.375 8.375 7.20711 8.375 7V2C8.375 1.94915 8.36488 1.90067 8.34655 1.85646Z",
    fill: "#8D9299"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLink);
export default __webpack_public_path__ + "static/media/icon-link.e9da3cec6f0b5b99ce76b920a6f5aa9c.svg";
export { ForwardRef as ReactComponent };